import React from 'react'
import { Route, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  FaTasks,
  FaWarehouse,
  FaUserCog,
  FaAward,
  FaUsers,
  FaUserCheck,
  FaToolbox
} from 'react-icons/fa'
import {
  MdDashboard,
  MdSettings,
  MdShoppingCart,
  MdComment,
  MdCardMembership
} from 'react-icons/md'
import { MdChevronLeft, MdExpandMore } from 'react-icons/md'
import { GoTasklist } from 'react-icons/go'

// import { userActions } from '../../_actions'

class NavMenu extends React.Component {
  // componentDidMount() {
  //     this.props.dispatch(userActions.getAll())
  // }
  render() {
    const { user, handleSidebarHide } = this.props
    return (
      <ul className="nav">
        {user && user.userType !== undefined && ![7].includes(user.userType) && (
          <Route path="/admin" exact>
            {({ match }) => (
              <li
                onClick={handleSidebarHide}
                onClick={handleSidebarHide}
                className={
                  match ? 'nav-item root-li active' : 'nav-item root-li'
                }>
                <Link to="/admin">
                  <MdDashboard className="mdi" size="24px" />
                  <span>داشبورد</span>
                </Link>
              </li>
            )}
          </Route>
        )}

        {/* {user && user.userType !== undefined && user.userType === 0 &&
          <Route path="/admin/tasks" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/tasks">
              <FaTasks className="mdi" size="24px" />
              <span>
                مدیریت فرآیند تولید
          </span>
            </Link></li>}
          </Route>
        } */}

        {user &&
          user.userType !== undefined &&
          [0, 1, 2, 3, 4, 6, 12].includes(user.userType) && (
            <Route
              path={
                '/admin/tasks/' +
                (user.userType == 1 || user.userType == 0 || user.userType == 3
                  ? 'sm'
                  : user.userType == 2
                  ? 'pm'
                  : user.userType == 4
                  ? 'ium'
                  : user.userType == 6
                  ? 'prum'
                  : user.userType == 12
                  ? 'whm'
                  : '')
              }
              exact>
              {({ match }) => (
                <li
                  onClick={handleSidebarHide}
                  onClick={handleSidebarHide}
                  className={
                    match ? 'nav-item root-li active' : 'nav-item root-li'
                  }>
                  <Link
                    to={
                      '/admin/tasks/' +
                      (user.userType == 1 ||
                      user.userType == 0 ||
                      user.userType == 3
                        ? 'sm'
                        : user.userType == 2
                        ? 'pm'
                        : user.userType == 4
                        ? 'ium'
                        : user.userType == 6
                        ? 'prum'
                        : user.userType == 12
                        ? 'whm'
                        : '')
                    }>
                    <GoTasklist className="mdi" size="24px" />
                    <span>مدیریت سفارشات تولید</span>
                  </Link>
                </li>
              )}
            </Route>
          )}

        {user &&
          user.userType !== undefined &&
          [8, 10].includes(user.userType) && (
            <Route path={'/admin/tasks/cum'} exact>
              {({ match }) => (
                <li
                  onClick={handleSidebarHide}
                  onClick={handleSidebarHide}
                  className={
                    match ? 'nav-item root-li active' : 'nav-item root-li'
                  }>
                  <Link to={'/admin/tasks/cum'}>
                    <GoTasklist className="mdi" size="24px" />
                    <span>مدیریت خط برش</span>
                  </Link>
                </li>
              )}
            </Route>
          )}

        {user &&
          user.userType !== undefined &&
          [8, 10].includes(user.userType) && (
            <Route path={'/admin/tasks/clum'} exact>
              {({ match }) => (
                <li
                  onClick={handleSidebarHide}
                  onClick={handleSidebarHide}
                  className={
                    match ? 'nav-item root-li active' : 'nav-item root-li'
                  }>
                  <Link to={'/admin/tasks/clum'}>
                    <GoTasklist className="mdi" size="24px" />
                    <span>مدیریت خط کلیک و بسته بندی</span>
                  </Link>
                </li>
              )}
            </Route>
          )}

        {user &&
          user.userType !== undefined &&
          [0, 1, 2, 3, 12, 13].includes(user.userType) && (
            <Route path="/admin/warehouses" exact>
              {({ match }) => (
                <li
                  onClick={handleSidebarHide}
                  onClick={handleSidebarHide}
                  className={
                    match ? 'nav-item root-li active' : 'nav-item root-li'
                  }>
                  <Link to="/admin/warehouses">
                    <FaWarehouse className="mdi" size="24px" />
                    <span>مدیریت انبارها</span>
                  </Link>
                </li>
              )}
            </Route>
          )}

        {user &&
          user.userType !== undefined &&
          [0, 1, 3].includes(user.userType) && (
            <Route path={'/admin/tasks/reserve'} exact>
              {({ match }) => (
                <li
                  onClick={handleSidebarHide}
                  onClick={handleSidebarHide}
                  className={
                    match ? 'nav-item root-li active' : 'nav-item root-li'
                  }>
                  <Link to={'/admin/tasks/reserve'}>
                    <GoTasklist className="mdi" size="24px" />
                    <span>رزرو سفارش</span>
                  </Link>
                </li>
              )}
            </Route>
          )}

        {/* {user && user.userType !== undefined && [1, 2].includes(user.userType) &&
          <Route path="/admin/shops" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/shops">
              <FaUserCheck className="mdi" size="24px" />
              <span>
                نمایندگان فروش
                  </span>
            </Link></li>}
          </Route>
        }
        {user && user.userType !== undefined && [1, 2].includes(user.userType) &&
          <Route path="/admin/orders" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/orders">
              <MdShoppingCart className="mdi" size="24px" />
              <span>
                سفارشات
                  </span>
            </Link></li>}
          </Route>
        }
        {user && user.userType !== undefined && [0].includes(user.userType) &&
          <Route path="/admin/installers" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/installers">
              <FaToolbox className="mdi" size="24px" />
              <span>
                نصاب ها
                  </span>
            </Link></li>}
          </Route>
        }
        {user && user.userType !== undefined && [0].includes(user.userType) &&
          <Route path="/admin/projects" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/projects">
              <FaLayerGroup className="mdi" size="24px" />
              <span>
                پروژه ها
                  </span>
            </Link></li>}
          </Route>
        }
        {user && user.userType !== undefined && user.userType === 1 &&
          <Route path="/admin/scores" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/scores">
              <FaAward className="mdi" size="24px" />
              <span>
                امتیازات
                  </span>
            </Link></li>}
          </Route>
        } */}
        {/* {user && user.userType !== undefined && user.userType === 1 &&
          <Route path="/admin/messages" exact>
            {({ match }) => <li onClick={handleSidebarHide} onClick={handleSidebarHide} className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/messages">
              <MdComment className="mdi" size="24px" />
              <span>
                مدیریت پیام ها
                  </span>
            </Link></li>}
          </Route>

        } */}

        {user && user.userType !== undefined && user.userType === 0 && (
          <Route path="/admin/Settings/:path(products|categories|brands|users|units|personnels)|/admin/:path(OrderExpirationRules|OrderExpirationExceptionRules)">
            {({ match }) => (
              <li
                className={
                  match ? 'nav-item root-li active' : 'nav-item root-li'
                }>
                <a
                  className={match ? 'nav-link' : 'nav-link collapsed'}
                  data-toggle="collapse"
                  aria-expanded={match ? 'true' : 'false'}
                  href="#Settings">
                  <MdSettings className="mdi" size="24px" />
                  <span>اطلاعات پایه</span>
                  <MdExpandMore style={{ verticalAlign: 'top' }} />
                </a>
                <div
                  className={match ? 'collapse in' : 'collapse'}
                  aria-expanded={match ? 'true' : 'false'}
                  id="Settings">
                  <ul className="nav">
                    <Route path="/admin/products" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/products">کالا ها</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/categories" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/categories">دسته بندی ها</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/brands" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/brands">برند ها</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/users" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/users">مدیریت کاربران</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/personnels" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/personnels">اطلاعات پرسنل</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/units" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/units">مدیریت واحد ها</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/banks" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/banks">مدیریت بانک ها</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/clients" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/clients">مدیریت طرف حساب ها</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/cargos" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/cargos">مدیریت باربری ها</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/drivers" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/drivers">مدیریت راننده ها</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/Provinces" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/Provinces">مدیریت استان ها</Link>
                        </li>
                      )}
                    </Route>
                    <Route path="/admin/cities" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/cities">مدیریت شهرها</Link>
                        </li>
                      )}
                    </Route>
                    {/* <Route path="/admin/:path(OrderExpirationRules|OrderExpirationExceptionRules)">
                      {({ match }) =>
                        <li className={match ? 'nav-item active root-li' : 'nav-item root-li'}>
                          <a className={match ? 'nav-link' : 'nav-link collapsed'} data-toggle="collapse" aria-expanded={match ? 'true' : 'false'}
                            href="#OrderExpirationRules">
                            <span> قوانین سفارش</span>

                            <MdChevronLeft />

                          </a>
                          <div className={match ? 'collapse in' : 'collapse'} aria-expanded={match ? 'true' : 'false'} id="OrderExpirationRules">
                            <ul className="nav">
                              <Route path="/admin/OrderExpirationRules" exact>
                                {({ match }) => <li onClick={handleSidebarHide} className={match ? 'nav-item active' : 'nav-item'}><Link to="/admin/OrderExpirationRules">ایام هفته</Link></li>}
                              </Route>
                              <Route path="/admin/OrderExpirationExceptionRules" exact>
                                {({ match }) => <li onClick={handleSidebarHide} className={match ? 'nav-item active' : 'nav-item'}><Link to="/admin/OrderExpirationExceptionRules">روزهای خاص</Link></li>}
                              </Route>
                            </ul>
                          </div>
                        </li>
                      }
                    </Route> */}
                  </ul>
                </div>
              </li>
            )}
          </Route>
        )}

        {user && user.userType !== undefined && user.userType === 0 && (
          <Route path="/admin/customers/:path(edit)">
            {({ match }) => (
              <li
                className={
                  match ? 'nav-item root-li active' : 'nav-item root-li'
                }>
                <a
                  className={match ? 'nav-link' : 'nav-link collapsed'}
                  data-toggle="collapse"
                  aria-expanded={match ? 'true' : 'false'}
                  href="#Customers">
                  <MdSettings className="mdi" size="24px" />
                  <span>مدیریت مشتریان</span>
                  <MdExpandMore style={{ verticalAlign: 'top' }} />
                </a>
                <div
                  className={match ? 'collapse in' : 'collapse'}
                  aria-expanded={match ? 'true' : 'false'}
                  id="Customers">
                  <ul className="nav">
                    <Route path="/admin/products" exact>
                      {({ match }) => (
                        <li
                          onClick={handleSidebarHide}
                          className={match ? 'nav-item active' : 'nav-item'}>
                          <Link to="/admin/customers">لیست مشتریان</Link>
                        </li>
                      )}
                    </Route>
                  </ul>
                </div>
              </li>
            )}
          </Route>
        )}
      </ul>
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}

const connectedNavMenu = connect(mapStateToProps)(NavMenu)
export { connectedNavMenu as NavMenu }
